import React, { Component } from 'react';
import logoBaka from "../../images/bakasable-logo.png"
import logoBlack from "../../images/logoBlack.png"
import {Icon} from 'react-fa'

class Footer extends Component {

  render() {
    return (
      <div className="footer">
        <img className="logoPetitDej" src={logoBlack}/>
        <p> par <a href="http://www.bakasable.fr/" target="_blank"><span className="orange">bakasable</span></a></p>
        <ul>
          <li><a target="_blank" href="https://www.instagram.com/agence_bakasable/"><Icon name="instagram" /></a></li>
          <li><a target="_blank" href="https://twitter.com/bakasable?lang=fr"><Icon name="twitter" /></a></li>
          <li><a target="_blank" href="https://www.facebook.com/bksbl/"><Icon name="facebook-f" /></a></li>
          <li><a target="_blank" href="https://www.behance.net/bakasable"><Icon name="behance" /></a></li>
        </ul>
      </div>
    )
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/client/components/partials/footer.js